<script setup>
import ChevronDown from "@/components/icons/ChevronDown.vue";
import {computed, onBeforeUnmount, onMounted, ref} from "vue";

const props = defineProps({
  title: {
    type: String,
    required: true,
    default: "",
  },
  modelValue: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  },
  show: {
    type: Boolean,
    default: false,
  },
  items: {
    type: Array,
    required: true,
    default: () => [],
  }
});

const emit = defineEmits(["update:modelValue", "update:show"]);

const localModelValue = computed(({
  set(value) {
    emit("update:modelValue", value);
  },
  get() {
    return props.modelValue;
  }
}));

const localShowValue = computed(({
  set(value) {
    emit("update:show", value);
  },
  get() {
    return props.show;
  }
}));

const modelValueLabel = computed(() => {
  return props.items.find((item) => item.value === props.modelValue)?.label;
});

const selectItem = (value) => {
  localShowValue.value = value;
  localShowValue.value = false;
};

const toggleShow = () => {
  localShowValue.value = !localShowValue.value;
};

const selectorRef = ref(null);
const selectorWidth = computed(() => {
  if (selectorRef.value) {
    return selectorRef.value.offsetWidth;
  } else {
    return 0;
  }
});

const preventScroll = (e) => {
  if (props.show) {
    const dropdownContent = document.querySelector(".dropdown"); // селектор списка
    if (!dropdownContent?.contains(e.target)) {
      e.preventDefault();
    }
  }
};

onMounted(() => {
  document.addEventListener("wheel", preventScroll, { passive: false });
});

onBeforeUnmount(() => {
  document.removeEventListener("wheel", preventScroll);
});

</script>

<template>
  <div
    ref="selectorRef"
    class="selector"
  >
    <span
      class="selector__title"
      :class="{'required-label': props.required}"
    >
      {{ props.title }}
    </span>
    <SimpleDropdown
      v-model="localModelValue"
      :is-visible="localShowValue"
      :items="items"
      :use-searchbar="false"
      :use-cross-icon="false"
      max-width="100%"
      max-height="210px"
      :width="selectorWidth"
      @close="toggleShow"
    >
      <template #trigger>
        <div
          class="selector__trigger"
          :class="{'selector__trigger--active': localShowValue}"
          @click="toggleShow"
        >
          {{ modelValueLabel }}
          <ChevronDown />
        </div>
      </template>
      <template #dropdown-item>
        <ListItem
          v-for="item in props.items"
          :key="item.value"
          v-model="localModelValue"
          :item="item"
          label-key="label"
          value-key="value"
          @click="selectItem(item.value)"
        >
          {{ item.label }}
        </ListItem>
      </template>
    </SimpleDropdown>
  </div>
</template>

<style scoped lang="scss">
.selector {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;

  &__title {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: var(--text-text-pur);
  }

  &__trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 12px;
    border-radius: 8px;
    background-color: var(--background-bg-white);
    border: 1px solid var(--border-bd-gray);
    height: 42px;
    cursor: pointer;

    svg {
      color: #CACACA;
    }

    &:hover {
      background-color: var(--background-bg-hover2);
    }

    &--active {
      background-color: var(--background-bg-hover2);
      border: 1px solid var(--border-bd-on);

      svg {
        color: var(--icon-icon-on);
        transform: rotateX(180deg);
      }
    }
  }
}

.required-label {
  justify-content: flex-start !important;
}

.required-label::after {
  content: ' *';
  color: red;
}
</style>